/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "noprod-idp-IdentityBrokerApi",
            "endpoint": "https://portal-be-noprod.idp.alperia.eu",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_tn1lD4rib",
    "aws_user_pools_web_client_id": "5bsid74ncbhtlas958r43h86r5",
    "oauth": {
        "domain": "auth-noprod.idp.alperia.eu",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://portal-noprod.idp.alperia.eu",
        "redirectSignOut": "https://portal-noprod.idp.alperia.eu/logout",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "portal-noprod.idp.alperia.eu",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://portal-noprod.idp.alperia.eu",
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "noprod-idp-IdentityBrokerClients-Table",
            "region": "eu-central-1"
        },
        {
            "tableName": "noprod-idp-IdentityBrokerCodes-Table",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;